import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { XSmall } from "@vitalsource/vstui/icons";
import { Button } from "@vitalsource/vstui/";
import { gaEvent } from "../../../utils/analytics";
import { selectors as bridgeSelectors } from "./../../../../redux/bridge";
import { selectors as brandSelectors } from "./../../../../redux/brand";
import { selectors as userSelectors } from "./../../../../redux/user";
import {
  selectors as storageSelectors,
  actions as storageActions
} from "./../../../../redux/storage";
import { withAllMatches } from "../../../components/mediaquery/breakpoints";
import { addParameter } from "../../../utils/location";
import {
  BannerGeneric,
  BannerStudy,
  BannerResearch,
  BannerExplore
} from "./allBanners";
import { ssoToOldOnlineURL } from "../../../utils/location";
import { t } from "../../../core/translate";

const BannerContainer = styled.div`
  width: 100%;
  padding: 10px 38px;
`;

const EmptyButton = styled.button`
  padding: 0;
  border: none;
  width: 100%;
  height: 100%;
  text-align: left;
`;
const CloseContainer = styled.div`
  position: absolute;
  right: 40px;
  z-index: 2;
`;

const BANNERS = [
  {
    label: "banner_generic",
    component: BannerGeneric
  },
  {
    label: "banner_study",
    component: BannerStudy
  },
  {
    label: "banner_research",
    component: BannerResearch
  },
  {
    label: "banner_explore",
    component: BannerExplore
  }
];

class Banner extends React.Component {
  constructor(props) {
    super(props);
    if (props.hasSubscriptions || !props.bannerAdsEnabled) {
      this.bannerNum = 3;
    } else {
      this.bannerNum = Math.floor(Math.random() * 3);
    }
    this.state = {
      closed: props.closed
    };
  }

  closeBanner = () => {
    gaEvent("BTS Store 2019", "click", "close_banner");
    this.props.seenBanner();
    this.setState({ closed: true });
  };

  clickBanner = e => {
    const storeUrl = addParameter(
      this.props.storeUrl,
      "utm_campaign",
      `b${this.bannerNum}`
    );
    e.preventDefault();
    ssoToOldOnlineURL(storeUrl, true, this.props.user);
    gaEvent("BTS Store 2019", "click", BANNERS[this.bannerNum].label);
  };

  render() {
    const {
      isSmall,
      isMedium,
      isTiny,
      bridgeFinishedFetching,
      isVitalSoureBrand
    } = this.props;
    const { closed } = this.state;

    if (!closed && bridgeFinishedFetching && isVitalSoureBrand) {
      const SelectedBanner = BANNERS[this.bannerNum].component;

      return (
        <BannerContainer>
          <CloseContainer>
            <Button
              naked
              size="large"
              color="white"
              onClick={this.closeBanner}
              iconStart={<XSmall />}
              label={t("base.close")}
            />
          </CloseContainer>
          <EmptyButton onClick={this.clickBanner} href={this.props.storeUrl}>
            <SelectedBanner
              isTiny={isTiny}
              isSmall={isSmall}
              isMedium={isMedium}
            />
          </EmptyButton>
        </BannerContainer>
      );
    }
    return null;
  }
}

const mapStateToProps = state => ({
  isVitalSoureBrand: brandSelectors.isVitalSoureBrand(state),
  bannerAdsEnabled: brandSelectors.bannerAdsEnabled(state),
  user: userSelectors.getUser(state),
  bridgeFinishedFetching: !bridgeSelectors.isUserFetching(state),
  hasSubscriptions: bridgeSelectors.hasSubscriptions(state),
  subscriptionsEnabled: brandSelectors.getBrandValue(
    state,
    "Subscriptions.enabled",
    true
  ),
  storeUrl: brandSelectors.getBrandedStoreUrl(state),
  closed: storageSelectors.getKey(state, "closedStoreBanner")
});

const mapDispatchToProps = dispatch => ({
  seenBanner: () => dispatch(storageActions.setKey("closedStoreBanner", true))
});

export default withTheme(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withAllMatches(Banner))
);
